import React from 'react';
import { Button, Divider, Grid, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";

const PaymentModal = ({ open, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box
        sx={{
          maxHeight: '90vh',
          overflowY: 'auto',
          width: 'calc(100% - 32px)',
          maxWidth: '500px',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '12px',
          boxShadow: 24,
          p: 2,
          backdropFilter: 'blur(6px)',
          border: '1px solid rgba(0, 0, 0, 0.1)',
          boxSizing: 'border-box'
        }}
      >
        {/* Header */}
        <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom>
          Unlock Full Access
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center" mb={3}>
          You're currently experiencing the preview subscription, limiting complete access to <b>only 2 profiles</b>. Upgrade now to avail <b>unlimited access</b> to all member profiles and <b>premium features</b> like favourite profiles.
        </Typography>

        {/* Actions */}
        <Grid container spacing={1} mb={2} mt={2}>
          <Grid item xs={12} sm={6}>
            <Button
              variant="contained"
              onClick={() => {
                window.open("https://rzp.io/rzp/gsbsoirika");
                onClose();
              }}
              fullWidth
              sx={{
                backgroundColor: '#3B82F6',
                textTransform: 'none',
                fontWeight: 'bold',
                py: 1.5,
                borderRadius: '8px',
                '&:hover': { backgroundColor: '#2563EB' },
              }}
            >
              Upgrade Now
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              variant="outlined"
              onClick={onClose}
              fullWidth
              sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                py: 1.5,
                borderRadius: '8px',
              }}
            >
              Maybe Later
            </Button>
          </Grid>
        </Grid>

        {/* Notes */}
        <Box mt={1} fontSize={14}>
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Please Note:
          </Typography>
          <ul style={{ paddingLeft: '20px', margin: 0, color: '#4B5563', listStyleType: 'disc' }}>
            <li style={{ marginBottom: 8 }}>
              Payments are verified within <strong>3 business days</strong>. If access isn't enabled after that, contact support at <a href="tel:+918296919479" style={{ color: '#3B82F6' }}>+91 8296919479</a>.
            </li>
            <li style={{ marginBottom: 8 }}>
              Only GSB community members are eligible. Ineligible accounts will be deactivated and <strong>payments will not be refunded</strong>.
            </li>
            <li style={{ marginBottom: 0 }}>
              If you cannot afford the subscription, please contact us at <a href="tel:+918296919479" style={{ color: '#3B82F6' }}>+91 8296919479</a>. We'll try to help.
            </li>
          </ul>
        </Box>
      </Box>
    </Modal>
  );
};

export default PaymentModal; 